<template>
  <div class="content">
    <el-upload
      ref="uploadRef"
      v-model="fileUrl"
      :action="server"
      :accept="accept"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :multiple="multiple"
      :drag="listType !='picture'"
      :limit="limit"
      :headers="header"
      :file-list="fileList"
      :list-type="listType"
    >

      <el-button v-if="listType==='picture'" size="small" type="primary">点击上传</el-button>

      <i v-if="listType !='picture'" class="el-icon-upload" />
      <div v-if="listType !='picture'" class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div v-if="tips" slot="tip" class="el-upload__tip">{{ tips }}</div>
    </el-upload>

  </div>

</template>

<script>

import { getToken } from '@/utils/auth'

export default {
  name: 'FileUploadLocal',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: [String, Array],
    // eslint-disable-next-line vue/require-default-prop
    accept: String,
    // eslint-disable-next-line vue/require-default-prop
    tips: String,
    // eslint-disable-next-line vue/require-default-prop
    listType: String,
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    // 可选自定义上传地址
    actionUrl: {
      type: String,
      default: ''
    },
    // 返回仅有文件名/Key时，用于拼出预览URL：/api/file/{bucket}/{key}
    bucket: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      server: `api/questions/uploadImage`,
      fileList: [],
      fileUrl: this.multiple ? [] : '',
      header: {}
    }
  },

  watch: {
    // 检测查询变化
    value: {
      handler() {
        this.fillValue()
      }
    }
  },

  created() {
    this.fillValue()
    this.header = { Authorization: getToken() }
    if (this.actionUrl) {
      this.server = this.actionUrl
    }
  },

  methods: {
    normalizePath(u) {
      if (!u) return ''
      let s = String(u).trim()
      while (s.length > 1 && s.endsWith('/')) {
        s = s.slice(0, -1)
      }
      return s
    },
    toPreviewUrl(u) {
      if (!u) return ''
      const s = this.normalizePath(u)
      // 未指定 bucket 时，直接返回原值，由后续逻辑统一加 /api 前缀
      if (!this.bucket) return s

      const b = this.bucket.replace(/^\/+|\/+$/g, '')

      // 已经是预览地址则直接返回
      if (/^\/api\/file\/preview\?path=/i.test(s)) {
        return s
      }

      // 规范出一个以 "/bucket/..." 开头的存储路径
      let storedPath = ''
      try {
        const url = new URL(s)
        const m = url.pathname.match(new RegExp(`/` + b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + `/([^?#]+)`))
        if (m && m[1]) storedPath = `/${b}/${m[1]}`
      } catch (_) {
        if (s.startsWith(`/${b}/`)) {
          storedPath = s
        } else if (s.startsWith(`${b}/`)) {
          storedPath = `/${b}/${s.slice(b.length + 1)}`
        } else if (s.startsWith(`/api/file/${b}/`)) {
          // 兼容旧格式 /api/file/bucket/key
          storedPath = `/${b}/${s.slice((`/api/file/${b}/`).length)}`
        } else if (s.startsWith('/')) {
          // 其它以 / 开头但不含 bucket，直接作为 path
          storedPath = s
        } else {
          // 仅文件名/key
          storedPath = `/${b}/${s}`
        }
      }

      storedPath = this.normalizePath(storedPath)

      if (!storedPath) return s
      return `/api/file/preview?path=${encodeURIComponent(storedPath)}`
    },

    toStoredPath(u) {
      // 期望输出：`/${bucket}/${key}`
      if (!u) return ''
      const s = this.normalizePath(u)
      if (!this.bucket) return s
      const b = this.bucket.replace(/^\/+|\/+$/g, '')
      // 已是期望格式
      if (s.startsWith(`/${b}/`)) return s
      try {
        const url = new URL(s)
        const m = url.pathname.match(new RegExp(`/` + b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + `/([^?#]+)`))
        if (m && m[1]) return `/${b}/${m[1]}`
      } catch (_) {
        if (s.startsWith(`/api/file/${b}/`)) return `/${b}/${s.slice((`/api/file/${b}/`).length)}`
        if (s.startsWith(`${b}/`)) return `/${b}/${s.slice(b.length + 1)}`
        if (s.startsWith(`/${b}/`)) return s
        // 仅文件名/key
        return `/${b}/${s.replace(/^\/+/, '')}`
      }
      return s
    },

    fillValue() {
      this.fileList = []
      if (this.multiple) {
        const arr = Array.isArray(this.value) ? [...this.value] : []
        this.fileUrl = arr.map(v => this.toPreviewUrl(v))
        if (this.fileUrl.length > 0) {
          this.fileList = this.fileUrl.map(url => ({ name: url, url: url }))
        }
      } else {
        this.fileUrl = this.toPreviewUrl(this.value || '')
        if (this.fileUrl) {
          this.fileList = [{ name: this.fileUrl, url: this.fileUrl }]
        }
      }
    },

    // 文件超出个数限制时的钩子
    handleExceed(files) {
      if (!this.multiple && this.limit === 1 && Array.isArray(files) && files.length > 0) {
        const upload = this.$refs.uploadRef
        if (upload && upload.clearFiles && upload.handleStart && upload.submit) {
          upload.clearFiles()
          upload.handleStart(files[0])
          upload.submit()
          return
        }
      }
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`)
    },
    // 删除文件之前的钩子
    beforeRemove(file) {
      return this.$confirm(`确定移除文件 ${file.name} 吗？`)
    },

    // 文件列表移除文件时的钩子
    handleRemove(file) {
      if (this.multiple) {
        const index = this.fileUrl.findIndex(url => url === file.url)
        if (index > -1) {
          this.fileUrl.splice(index, 1)
          this.$emit('input', [...this.fileUrl])
        }
      } else {
        this.$emit('input', '')
        this.fileList = []
      }
    },

    // 文件上传成功时的钩子
    handleSuccess(response, file) {
      const pickUrl = (resp) => {
        if (!resp) return ''
        if (resp.data && typeof resp.data === 'string') return resp.data
        if (resp.data && typeof resp.data === 'object') {
          if (resp.data.url) return resp.data.url
          if (resp.data.path) return resp.data.path
          if (resp.data.fileUrl) return resp.data.fileUrl
          if (resp.data.key) return resp.data.key
          if (resp.data.filename) return resp.data.filename
        }
        if (resp.url) return resp.url
        if (resp.path) return resp.path
        if (resp.key) return resp.key
        return ''
      }
      let ok = true
      if (typeof response.code === 'number') {
        ok = [1, 200, 0].includes(response.code)
      }
      if (!ok && response.success !== undefined) ok = !!response.success
      if (!ok && response.status !== undefined) {
        const st = String(response.status)
        ok = st === '200' || st.startsWith('2')
      }
      // 不强制中断，尽量继续处理预览地址

      let raw = this.normalizePath(pickUrl(response))
      const preview = this.toPreviewUrl(raw)
      const stored = this.bucket ? this.normalizePath(this.toStoredPath(raw)) : this.normalizePath(preview)
      // 规范化相对路径预览 URL
      let url = preview
      if (url && !/^https?:\/\//i.test(url)) {
        if (this.bucket) {
          // 输入可能是："/amc-question-test/xxx.png"、"amc-question-test/xxx.png" 或仅 "xxx.png"
          const b = this.bucket.replace(/^\/+|\/+$/g, '')
          if (url.startsWith(`/api/file/`)) {
            // 已是正确前缀，保留
          } else if (url.startsWith(`/${b}/`)) {
            const key = url.slice(b.length + 2)
            url = `/api/file/${b}/${key}`
          } else if (url.startsWith(`${b}/`)) {
            const key = url.slice(b.length + 1)
            url = `/api/file/${b}/${key}`
          } else if (url.startsWith('/')) {
            // 其它以 / 开头但不含 bucket，退化为 /api + 原路径
            url = `/api${url}`
          } else {
            // 仅文件名/key
            url = `/api/file/${b}/${url}`
          }
        } else {
          // 无 bucket，则统一补 /api 前缀
          if (url.startsWith('/api/')) {
            // ok
          } else if (url.startsWith('/')) {
            url = '/api' + url
          } else {
            url = '/api/' + url
          }
        }
      }
      this.$message({ type: 'success', message: response.msg || '上传成功' })

      if (this.multiple) {
        const oldValues = Array.isArray(this.value) ? [...this.value] : []
        const newValues = [...oldValues, stored]
        this.$emit('input', newValues)
        this.fileUrl = newValues.map(v => this.toPreviewUrl(v))
        this.fileList = this.fileUrl.map(u => ({ name: u, url: u }))
      } else {
        this.$emit('input', stored)
        const pv = this.toPreviewUrl(stored)
        this.fileUrl = pv
        this.fileList = pv ? [{ name: pv, url: pv }] : []
      }
    }

  }
}
</script>
